import React, { Component } from 'react'

import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,MDBDataTable,MDBRow ,MDBCol ,MDBJumbotron} from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
//import Login from './Login';
import Axios from 'axios'
import { URL } from '../../api';
import logo from '../img/logokpru.png'
import FadeIn from 'react-fade-in';
import p1 from '../img/1656587759_2-illustration_png.png'
import p2 from '../img/1656587759_4-illustration_png.png'
import p3 from '../img/1656587761_12-illustration_png.png'
import Iframe from 'react-iframe'
import IframeResizer from 'iframe-resizer-react'

import { HorizontalBar } from 'react-chartjs-2';


import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';


export default class Namelistall extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,
      selectregistertypesum:[],

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
  }

  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  refreshPage() {
    window.location.reload(false);
  }

  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }


  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }

  componentDidMount() {
  
    setTimeout(() => {
        Axios.get('https://mua.kpru.ac.th/FrontEnd_Conferencekpru/registercon/selectregistertypesum', )
        .then(res => {
          console.log(res);
          this.setState({ selectregistertypesum: res.data})
        }) 
      }, 0);

  }


  render() {


    const datast = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อ - นามสกุล',
            field: 'name_article',
            sort: 'name_article',
            width: 150
          },
          {
            label: 'มหาวิทยาลัย',
            field: 'name_present',
            sort: 'name_present',
            width: 150
          },
          {
            label: 'คณะสาขา',
            field: 'major_precent',
            sort: 'major_precent',
            width: 150
          },
         
      
        
        ],
  
  
        rows: [...this.state.selectregistertypesum.map((data, i) => (
      
          {
     
  
             list: <>{i+1}</>,
             name_article: <>{data.FULLNAME}{data.register_nameth} {data.register_lnameth}</>,
             name_present: <>{data.register_nameuniversity}</>,
             major_precent: <>คณะ: {data.price_typeregister	} </>,
           
            
          }
         ))]
    
        };
        const persons = <MDBDataTable
        // searching ={true}
          searchLabel="ค้นหา ชื่อ - นามสกุล"
          striped
          bordered
          small 
          entries={50}
        // entriesOptions={["10", "20"]}
          order={["age", "desc"]}
          data={datast}
          entriesLabel="จำนวนที่แสดง "
          infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
          paginationLabel={["ย้อนกลับ", "ถัดไป"]}
          responsive 
        //  sortRows={['name_article']}
           theadColor="grey lighten-1"
           
        //  theadColor={"#ff4444"}
          />

 



    return (

      <MDBContainer fluid>
       
        <MDBRow >
          <MDBCol md="12">
            <div>
            
              <FadeIn>
              <MDBJumbotron className="p-4" fluid >
                 
                <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />   จำนวนนักศึกษายังไม่ชำระเงินลงทะเบียน
                </MDBTypography>
              
{persons}
                       
        
              </MDBJumbotron>
              </FadeIn>
            </div>
          </MDBCol>
        </MDBRow>

      </MDBContainer>


    )
  }
}
